import React, { useState, useEffect } from "react";
import { authService } from "../services/authService";

function Home({ onLogout }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const currentUser = authService.getUser();
    setUser(currentUser);
  }, []);

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h1 style={styles.title}>Welcome to KansasRoot</h1>
        {user && (
          <div style={styles.userInfo}>
            <p style={styles.welcomeText}>
              Welcome, {user.firstName} {user.lastName}!
            </p>
            <button onClick={onLogout} style={styles.logoutBtn}>
              Logout
            </button>
          </div>
        )}
      </div>

      {user && (
        <div style={styles.userDetails}>
          <h2>Your Profile</h2>
          <div style={styles.detailsCard}>
            <p><strong>Email:</strong> {user.email}</p>
            <p><strong>Name:</strong> {user.firstName} {user.lastName}</p>
            <p><strong>Address:</strong> {user.address || "N/A"}</p>
            <p><strong>Company:</strong> {user.companyName || "N/A"}</p>
            <p><strong>Role:</strong> {user.role}</p>
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  container: {
    padding: "2rem",
    maxWidth: "1000px",
    margin: "0 auto",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "2rem",
  },
  title: {
    fontSize: "2.5rem",
    color: "#1a237e",
    margin: 0,
  },
  userInfo: {
    textAlign: "right",
  },
  welcomeText: {
    fontSize: "1.1rem",
    color: "#666",
    margin: "0 0 1rem 0",
  },
  logoutBtn: {
    background: "#d32f2f",
    color: "#fff",
    padding: "0.75rem 1.5rem",
    border: "none",
    borderRadius: "4px",
    fontSize: "1rem",
    fontWeight: "600",
    cursor: "pointer",
  },
  userDetails: {
    marginTop: "2rem",
  },
  detailsCard: {
    background: "#f5f7fa",
    padding: "1.5rem",
    borderRadius: "8px",
    border: "1px solid #ddd",
  },
};

export default Home;
